import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Ecunel Fitness Gym - Το Καλύτερο Blog για Fitness</title>
        <meta name="description" content="Ecunel Fitness Gym - Το καλύτερο blog για fitness, προπονήσεις και υγιεινή ζωή στην Ελλάδα" />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Όροι και Προϋποθέσεις Χρήσης</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Εισαγωγή</h2>
          <p>
            Καλώς ήρθατε στο Ecunel Fitness Gym. Αυτοί οι όροι και προϋποθέσεις περιγράφουν τους κανόνες και 
            τους κανονισμούς για τη χρήση του ιστότοπου της Ecunel Fitness Gym, που βρίσκεται στη διεύθυνση 
            https://ecunel.com.
          </p>
          <p>
            Με την πρόσβαση σε αυτόν τον ιστότοπο, υποθέτουμε ότι αποδέχεστε αυτούς τους όρους και προϋποθέσεις. 
            Μην συνεχίσετε να χρησιμοποιείτε το Ecunel Fitness Gym εάν δεν συμφωνείτε να τηρήσετε όλους τους 
            όρους και τις προϋποθέσεις που αναφέρονται σε αυτήν τη σελίδα.
          </p>
        </section>

        <section>
          <h2>2. Ορολογία</h2>
          <p>
            Η ακόλουθη ορολογία ισχύει για τους παρόντες Όρους και Προϋποθέσεις, τη Δήλωση Απορρήτου και 
            τη Δήλωση Αποποίησης Ευθυνών και όλες τις Συμφωνίες:
          </p>
          <ul>
            <li><strong>"Πελάτης"</strong>, <strong>"Εσείς"</strong> και <strong>"Δικός σας"</strong> αναφέρεται σε εσάς, το άτομο που συνδέεται σε αυτόν τον ιστότοπο.</li>
            <li><strong>"Η Εταιρεία"</strong>, <strong>"Εμείς"</strong>, <strong>"Μας"</strong> και <strong>"Δικός μας"</strong> αναφέρεται στην Ecunel Fitness Gym.</li>
            <li><strong>"Μέρη"</strong> αναφέρεται τόσο στον Πελάτη όσο και σε εμάς.</li>
          </ul>
        </section>

        <section>
          <h2>3. Άδεια Χρήσης</h2>
          <p>
            Εκτός αν δηλώνεται διαφορετικά, η Ecunel Fitness Gym και/ή οι αδειοδότες της κατέχουν τα δικαιώματα 
            πνευματικής ιδιοκτησίας για όλο το υλικό στο Ecunel Fitness Gym. Όλα τα δικαιώματα πνευματικής 
            ιδιοκτησίας διατηρούνται. Μπορείτε να έχετε πρόσβαση σε αυτό από το Ecunel Fitness Gym για προσωπική 
            σας χρήση με τους περιορισμούς που ορίζονται σε αυτούς τους όρους και προϋποθέσεις.
          </p>
          <p>Δεν πρέπει:</p>
          <ul>
            <li>Να αναδημοσιεύετε υλικό από το Ecunel Fitness Gym</li>
            <li>Να πουλάτε, να ενοικιάζετε ή να παραχωρείτε υπο-άδειες για υλικό από το Ecunel Fitness Gym</li>
            <li>Να αναπαράγετε, να αντιγράφετε ή να κάνετε αντίγραφα υλικού από το Ecunel Fitness Gym</li>
            <li>Να αναδιανέμετε περιεχόμενο από το Ecunel Fitness Gym</li>
          </ul>
        </section>

        <section>
          <h2>4. Σχόλια Χρηστών</h2>
          <p>
            Ορισμένα μέρη αυτού του ιστότοπου προσφέρουν τη δυνατότητα στους χρήστες να δημοσιεύουν και να 
            ανταλλάσσουν απόψεις και πληροφορίες. Η Ecunel Fitness Gym δεν φιλτράρει, επεξεργάζεται, δημοσιεύει 
            ή εξετάζει τα σχόλια πριν από την παρουσία τους στον ιστότοπο.
          </p>
          <p>
            Τα σχόλια δεν αντικατοπτρίζουν τις απόψεις και τις γνώμες της Ecunel Fitness Gym, των αντιπροσώπων 
            της ή/και των συνεργατών της. Τα σχόλια αντικατοπτρίζουν τις απόψεις και τις γνώμες του ατόμου που 
            δημοσιεύει τις απόψεις και τις γνώμες του.
          </p>
          <p>Δεσμεύεστε ότι τα σχόλιά σας:</p>
          <ul>
            <li>Δεν είναι παράνομα, δυσφημιστικά, προσβλητικά, άσεμνα ή παραβιάζουν την ιδιωτικότητα</li>
            <li>Δεν θα χρησιμοποιηθούν για να ζητήσουν ή να προωθήσουν επιχειρήσεις</li>
            <li>Δεν περιέχουν ιούς ή κακόβουλο λογισμικό</li>
            <li>Δεν παραβιάζουν τα δικαιώματα πνευματικής ιδιοκτησίας τρίτων</li>
          </ul>
        </section>

        <section>
          <h2>5. Υπερσύνδεσμοι στο Περιεχόμενό μας</h2>
          <p>
            Οι ακόλουθοι οργανισμοί μπορούν να συνδεθούν με τον ιστότοπό μας χωρίς προηγούμενη γραπτή έγκριση:
          </p>
          <ul>
            <li>Κυβερνητικές υπηρεσίες</li>
            <li>Μηχανές αναζήτησης</li>
            <li>Οργανισμοί ειδήσεων</li>
            <li>Διανομείς διαδικτυακών καταλόγων</li>
            <li>Επιχειρήσεις με διαπιστευμένη παρουσία σε όλο το σύστημα</li>
          </ul>
        </section>

        <section>
          <h2>6. Ευθύνη Περιεχομένου</h2>
          <p>
            Δεν θα φέρουμε ευθύνη για οποιοδήποτε περιεχόμενο εμφανίζεται στον ιστότοπό σας. Συμφωνείτε να μας 
            προστατεύσετε και να μας υπερασπιστείτε έναντι όλων των αξιώσεων που ανακύπτουν στον ιστότοπό σας.
          </p>
          <p>
            Κανένας σύνδεσμος(-οι) δεν πρέπει να εμφανίζεται σε οποιονδήποτε ιστότοπο που μπορεί να ερμηνευθεί 
            ως δυσφημιστικός, άσεμνος ή εγκληματικός, ή που παραβιάζει, παραβιάζει με άλλο τρόπο ή υποστηρίζει 
            την παραβίαση ή άλλη παραβίαση των δικαιωμάτων τρίτων.
          </p>
        </section>

        <section>
          <h2>7. Επιφύλαξη Δικαιωμάτων</h2>
          <p>
            Διατηρούμε το δικαίωμα να ζητήσουμε να αφαιρέσετε όλους τους συνδέσμους ή οποιονδήποτε συγκεκριμένο 
            σύνδεσμο προς τον ιστότοπό μας. Εγκρίνετε να αφαιρέσετε αμέσως όλους τους συνδέσμους προς τον 
            ιστότοπό μας κατόπιν αιτήματος.
          </p>
          <p>
            Επίσης, διατηρούμε το δικαίωμα να τροποποιήσουμε αυτούς τους όρους και την πολιτική σύνδεσης ανά 
            πάσα στιγμή. Συνδέοντας συνεχώς με τον ιστότοπό μας, συμφωνείτε να δεσμεύεστε και να ακολουθείτε 
            αυτούς τους όρους σύνδεσης.
          </p>
        </section>

        <section>
          <h2>8. Αφαίρεση Συνδέσμων από τον Ιστότοπό μας</h2>
          <p>
            Εάν βρείτε οποιονδήποτε σύνδεσμο στον ιστότοπό μας που είναι προσβλητικός για οποιονδήποτε λόγο, 
            είστε ελεύθεροι να επικοινωνήσετε και να μας ενημερώσετε ανά πάσα στιγμή. Θα εξετάσουμε αιτήματα 
            αφαίρεσης συνδέσμων, αλλά δεν είμαστε υποχρεωμένοι να το κάνουμε ή να απαντήσουμε απευθείας σε εσάς.
          </p>
        </section>

        <section>
          <h2>9. Αποποίηση Ευθύνης</h2>
          <p>
            Στο μέγιστο βαθμό που επιτρέπεται από την ισχύουσα νομοθεσία, εξαιρούμε όλες τις εκπροσωπήσεις, 
            εγγυήσεις και όρους που σχετίζονται με τον ιστότοπό μας και τη χρήση αυτού του ιστότοπου.
          </p>
          <p>Τίποτα σε αυτήν την αποποίηση ευθύνης δεν θα:</p>
          <ul>
            <li>Περιορίζει ή εξαιρεί την ευθύνη μας ή τη δική σας για θάνατο ή τραυματισμό</li>
            <li>Περιορίζει ή εξαιρεί την ευθύνη μας ή τη δική σας για απάτη ή δόλια παραπλάνηση</li>
            <li>Περιορίζει οποιεσδήποτε από τις ευθύνες μας ή τις δικές σας με οποιονδήποτε τρόπο που δεν επιτρέπεται από την ισχύουσα νομοθεσία</li>
            <li>Εξαιρεί οποιεσδήποτε από τις ευθύνες μας ή τις δικές σας που δεν μπορούν να εξαιρεθούν σύμφωνα με την ισχύουσα νομοθεσία</li>
          </ul>
        </section>

        <section>
          <h2>10. Περιορισμοί και Εξαιρέσεις Ευθύνης</h2>
          <p>
            Οι περιορισμοί και οι εξαιρέσεις ευθύνης που ορίζονται σε αυτήν την ενότητα και αλλού σε αυτήν την 
            αποποίηση ευθύνης: (α) υπόκεινται στην προηγούμενη παράγραφο, και (β) διέπουν όλες τις ευθύνες που 
            προκύπτουν βάσει της αποποίησης ευθύνης.
          </p>
          <p>
            Εφόσον ο ιστότοπος και οι πληροφορίες και οι υπηρεσίες στον ιστότοπο παρέχονται δωρεάν, δεν θα 
            ευθυνόμαστε για οποιαδήποτε απώλεια ή ζημία οποιασδήποτε φύσης.
          </p>
        </section>

        <section>
          <h2>11. Πληροφορίες Υγείας</h2>
          <p>
            Το περιεχόμενο του ιστότοπου Ecunel Fitness Gym, όπως κείμενο, γραφικά, εικόνες και άλλο υλικό που 
            περιέχεται στον ιστότοπο ("Περιεχόμενο"), είναι μόνο για ενημερωτικούς σκοπούς. Το Περιεχόμενο δεν 
            προορίζεται να υποκαταστήσει την επαγγελματική ιατρική συμβουλή, διάγνωση ή θεραπεία.
          </p>
          <p>
            Ζητήστε πάντα τη συμβουλή του γιατρού σας ή άλλου εξειδικευμένου παρόχου υγείας σχετικά με 
            οποιεσδήποτε ερωτήσεις μπορεί να έχετε σχετικά με μια ιατρική κατάσταση. Μην αγνοείτε ποτέ 
            επαγγελματικές ιατρικές συμβουλές ή να καθυστερείτε να τις αναζητήσετε εξαιτίας κάποιου πράγματος 
            που διαβάσατε στον ιστότοπο Ecunel Fitness Gym.
          </p>
        </section>

        <section>
          <h2>12. Τροποποιήσεις</h2>
          <p>
            Η Ecunel Fitness Gym διατηρεί το δικαίωμα να αναθεωρεί αυτούς τους όρους ανά πάσα στιγμή όπως 
            κρίνει σκόπιμο, και χρησιμοποιώντας αυτόν τον ιστότοπο αναμένεται να εξετάζετε τακτικά αυτούς 
            τους όρους.
          </p>
        </section>

        <section>
          <h2>13. Ισχύον Δίκαιο</h2>
          <p>
            Αυτοί οι όροι και προϋποθέσεις διέπονται και ερμηνεύονται σύμφωνα με τους νόμους της Ελλάδας και 
            υποβάλλετε ανεπιφύλακτα στην αποκλειστική δικαιοδοσία των δικαστηρίων σε αυτή τη χώρα.
          </p>
        </section>

        <section>
          <h2>14. Επικοινωνία</h2>
          <p>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με τους όρους και τις προϋποθέσεις μας, επικοινωνήστε μαζί μας:
          </p>
          <ul>
            <li>Email: <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a></li>
            <li>Ιστότοπος: https://ecunel.com</li>
          </ul>
        </section>
      </div>
    </div>
  
    </>);
};

export default TermsConditions;